import * as React from 'react';
import styled from 'styled-components';
import * as constants from '@latitude/core/utils/constants';

var Icon = function Icon(_ref) {
  var id = _ref.id,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? constants.COLOR.BLACK : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? constants.ICON_SIZE.MD : _ref$size,
      variant = _ref.variant;
  var props = {
    id: id,
    className: className,
    color: color,
    size: size
  };

  var Svg = require("./svg/" + variant + ".svg");

  var StyledSvg = /*#__PURE__*/styled(Svg).withConfig({
    displayName: "Icon__StyledSvg",
    componentId: "sc-1bwa8n9-0"
  })(["", ""], function (_ref2) {
    var size = _ref2.size,
        color = _ref2.color;
    return "\n      width: " + size + ";\n      height: " + size + ";\n      fill: none;\n      stroke: " + color + ";\n      stroke-width: 3px;\n      stroke-miterlimit: 10;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n    ";
  });
  return /*#__PURE__*/React.createElement(StyledSvg, props);
};

export default Icon;